import { render } from "./ExpandedNavFrame.vue?vue&type=template&id=fbad136a"
import script from "./ExpandedNavFrame.vue?vue&type=script&lang=js"
export * from "./ExpandedNavFrame.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__